import { Reveal } from "@/components/Reveal";
import { ClipboardList } from "lucide-react";

export const PlannerBand = () => (
    <section data-testid="planner-band" className="border-y border-[#d4af37]/25 bg-[#121216]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14 flex flex-col md:flex-row md:items-center gap-8 justify-between">
            <Reveal>
                <div className="flex items-start gap-5">
                    <ClipboardList size={26} className="text-[#d4af37] mt-1 shrink-0" />
                    <div>
                        <h2 className="font-serif text-2xl sm:text-3xl font-light text-[#fafafa]">
                            Wedding planners &amp; venues
                        </h2>
                        <p className="mt-2 text-sm sm:text-base text-[#a1a1aa] leading-relaxed max-w-xl">
                            Custom ensembles from string quartet to full orchestra, tailored to your client&rsquo;s
                            vision and budget — in Los Angeles, Southern California, and destinations worldwide.
                        </p>
                    </div>
                </div>
            </Reveal>
            <Reveal delay={0.1}>
                <a href="mailto:Info@agnmusic.com?subject=Planner%20Enquiry%20—%20Allen%20G.%20Orchestra"
                    data-testid="planner-email-btn"
                    className="inline-flex items-center px-7 py-3.5 text-xs uppercase tracking-[0.25em] border border-[#d4af37] text-[#d4af37] hover:bg-[#d4af37] hover:text-[#08080a] transition-colors duration-300 whitespace-nowrap">
                    Partner With Us
                </a>
            </Reveal>
        </div>
    </section>
);
